import actionTypes from '../../action-types'

export default (payload) => ({
  type: actionTypes.CUSTOMERS.CREATE,
  payload,
})
